import React from "react"
import { Container,Row,Col } from 'react-bootstrap'
import Logo from "../images/logo.inline.svg"

const Footer = () => {
  return (
<Row className="footer">
        <Container>
          <div className="footer__widgets">
            <Row>
            <div className="col-lg-3">
              <a href="https://card.dagcoin.org" className="footer-logo">
                <Logo />
              </a>
            </div>
              <div className="col-lg-9">
                  <div className="footer-bottom">
                      <p>Dagcoin Card 2020</p>
                      <p>Copyright (c), all rights reserved</p>
                  </div>
              </div>
            </Row>
          </div>    
        </Container>
      </Row>
  )
}
export default Footer